export function formatSentenceCase(value: string): string {
  const trimmed = value.trim();
  if (!trimmed) {
    return value;
  }
  return (
    trimmed.charAt(0).toLocaleUpperCase() +
    trimmed.slice(1).toLocaleLowerCase()
  );
}
